export const validShareRef = (value: unknown): value is string => typeof value === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(value)
function https(value: unknown) {
  if (typeof value !== 'string' || !value || value !== value.trim() || /[?#@]/.test(value)) return null
  try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password && !url.search && !url.hash ? url : null } catch { return null }
}
export function invitationUrl(value: unknown, approvedOrigin: unknown, ref: string): string | null {
  const url = https(value), origin = https(approvedOrigin)
  if (!validShareRef(ref) || !url || !origin || origin.pathname !== '/' || url.origin !== origin.origin || url.pathname !== `/invite/${ref}`) return null
  return url.href
}
export function invitationStoreUrl(value: unknown, approved: unknown): string | null {
  const url = https(value), target = https(approved)
  return url && target && target.hostname === 'apps.apple.com' && target.port === '' && /^\/(?:[a-z]{2}\/)?app\/(?:[^/]+\/)?id\d+$/.test(target.pathname) && url.href === target.href ? url.href : null
}
